import axios from "axios";
import { toast } from "react-toastify";
import { CONTACTS_LIST } from "../../Store/Type";
import { api } from "./VaultApi";


const apiUrl = process.env.REACT_APP_API_URL;

const getUserId = () => {
  return (
    sessionStorage.getItem("USER_ID") ||
    localStorage.getItem("USER_ID") ||
    "0001"
  );
};

export const GetContactsData = async ({
  dispatch,
  page = 1,
  limit = 10,
  sort_order = "A",
  sort_column = "contact_id",
  filter_category = "",
  search = "",
}) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("limit", limit);
  params.append("sort_order", sort_order);
  params.append("sort_column", sort_column);

  if (filter_category) {
    params.append("filter_category", filter_category);
  }

  if (search?.trim()) {
    params.append("search", search.trim());
  }

  try {
    const response = await api.get(`${apiUrl}/getAllContact?${params.toString()}`);

    dispatch({
      type: CONTACTS_LIST,
      payload: response?.data?.data || [],
      pageContext: response?.data?.pageContext || {},
    });

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const GetContactById = async (contactId) => {
  try {
    const response = await api.get(`${apiUrl}/getContactById/${contactId}`);
    return response?.data?.[0] || null;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SubmitContactData = async (values, contactId) => {
  const payload = {
    contact_name: values.contact_name || "",
    designation: values.designation || "",
    organisation: values.organisation || "",
    category: values.category || "",
    priority: values.priority || "",
    email: values.email || "",
    phone: values.phone || "",
    notes: values.notes || "",
    user_id: getUserId(),
    is_sensitive: values?.is_sensitive === true ? true : "false",
  };

  const url = contactId
    ? `${apiUrl}/updateContactById/${contactId}`
    : `${apiUrl}/addContact`;

  const method = contactId ? "put" : "post";

  try {
    const response = await api({
      method,
      url,
      data: payload,
    });

    toast.success(
      contactId ? response?.data?.message||"Contact updated successfully" : "Contact added successfully"
    );

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const DeleteContact = async (
  contactId,
  dispatch = null,
  filters = {},
  autoRefresh = true
) => {
  try {
    const userId = getUserId();

    const response = await api.delete(
      `${apiUrl}/deleteContactById/${contactId}/${userId}`
    );

    toast.success(response?.data?.message || "Contact deleted successfully");

    if (autoRefresh && typeof dispatch === "function") {
      GetContactsData({
        dispatch,
        ...filters,
      });
    }

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

const handleError = (error) => {
  console.error("Contact API Error:", error);

  let errorMessage = "An error occurred";

  if (error.response) {
    errorMessage =
      error?.response?.data?.message ||
      `Server responded with status ${error.response.status}`;
  } else if (error.request) {
    errorMessage = "No response received from server";
  } else {
    errorMessage = error.message;
  }

  if (
    error.code === "ERR_NETWORK" ||
    error.code === "ERR_CONNECTION_REFUSED"
  ) {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }

  toast.error(errorMessage);
};

export const UpdateContactFavorite = async (row, isFavorite) => {
  const status = isFavorite === true ? true : "false"
  const payload = {
    status: status,
    user_id: getUserId(),
  };
  try {
    const response = await api.put(
      `${apiUrl}/updateContactFavoriteStatus/${row.contact_id}`,
      payload
    );
    toast.success(isFavorite ? "Contact pinned" : "Contact unpinned");
    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const ValidateContactOtp = async (payload, contactId) => {
  try {
    const response = await api.put(
      `${apiUrl}/verifyotp/updateContactById/${contactId}`,
      payload
    );

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const UpdateContactSensitive = async (row, status) => {
  try {
    const response = await api.put(
      `${apiUrl}/updatecontactstauts/${row.contact_id}`,
      {
        status: status,
        user_id: getUserId(),
      }
    );

    toast.success(
      response?.data?.message ||
        (status ? "Contact locked" : "OTP sent successfully")
    );

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateContactSensitiveOtp = async (payload, contactId) => {
  try {
    const response = await api.put(
      `${apiUrl}/verifyotp/updatecontactstauts/${contactId}`,
      payload
    );

    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ValidateContactDeleteOtp = async (payload, contactId) => {
  try {
    const response = await api.put(
      `${apiUrl}/verifyotp/deleteContactById/${contactId}`,
      payload
    );

    // toast.success("Contact deleted successfully");
    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ShareContactMail = async ({contact_id,email}) => {
  try {
    const response = await api.post(
      `${apiUrl}/sendContactMail`,
      {
  contact_id: contact_id,
  user_id:getUserId(),
  email:email,
}
    );
    console.log(response?.data?.messsage,"response");
    toast.success(response?.data?.messsage || "Contact Shared successfully");
    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const ValidateOtpShareContactMail = async ({contact_id,email,otp}) => {
  try {
    const response = await api.post(
      `${apiUrl}/validateMailContact`,
      {
  contact_id: contact_id,
  user_id:getUserId(), 
  email:email,
  otp:otp
}
    );
    toast.success(response?.data?.message || "Contact shared successfully");
    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};